<script lang="ts">
  import TimedToast from "$lib/components/TimedToast.svelte";
  import UserMenu from "$lib/components/UserMenu.svelte";
  import { createToastStore } from "$lib/stores/toasts";
  import type { ToastStore } from "$lib/stores/toasts";
  import { userStore } from "$lib/stores/user";
  import { NavBrand } from "flowbite-svelte";
  import { getContext, setContext } from "svelte";
  import "../app.css";
  import type { LayoutData } from "./$types";
  import { page } from "$app/stores";

  const toastStore =
    getContext<ToastStore | undefined>("toasts") ?? createToastStore();
  setContext("toasts", toastStore);

  export let data: LayoutData;

  const environments = [
    {
      stage: "prod",
      label: "LOQL PROD",
      url: "https://backoffice.loql.com",
      logo: "/logo.svg",
    },
    {
      stage: "test",
      label: "LOQL TEST",
      url: "https://backoffice.loql-test.com",
      logo: "/logo.svg",
    },
    {
      stage: "int",
      label: "LOQL INTEGRATION",
      url: "https://backoffice.loql-integration.com",
      logo: "/logo.svg",
    },
    {
      stage: "ocf-prod",
      label: "OCFLOW PROD",
      url: "https://backoffice.ocflow.com",
      logo: "/ocflow_darkblue_logo.svg",
    },
    {
      stage: "ocf-dev",
      label: "OCFLOW DEV",
      url: "https://backoffice.ocflow-dev.com",
      logo: "/ocflow_darkblue_logo.svg",
    },
  ];

  function onEnvironmentChange(event: Event) {
    const target = event.target as HTMLSelectElement;
    if (target.value) {
      window.location.href = target.value;
    }
  }

  function handleClosed({ detail: { id } }: CustomEvent<{ id: number }>) {
    toastStore.remove(id);
  }

  setContext("page", page);
</script>

<header class="container mx-auto max-w-7xl relative">
  <nav
    class="bg-white text-gray-700 border-gray-100 divide-gray-100 px-2 py-2.5 w-full"
  >
    <div class="flex flex-row flex-wrap justify-between items-center">
      <div class="flex items-center">
        <NavBrand href="/companies" class="sm:px-0 ml-3">
          <img
            src={environments.find((e) => e.stage === data.properties.stage)
              ?.logo ?? "/logo.svg"}
            class="mr-3 h-6 sm:h-9"
            alt="Logo"
          />
        </NavBrand>
        {#if data?.properties}
          <select
            class="font-bold -ml-2 text-2xl border-none bg-transparent cursor-pointer focus:ring-0 pr-8"
            value={environments.find((e) => e.stage === data.properties.stage)
              ?.url ?? ""}
            on:change={onEnvironmentChange}
          >
            {#each environments as env (env.stage)}
              <option value={env.url}>{env.label} Umgebung</option>
            {/each}
          </select>
        {/if}
      </div>
      {#if $userStore !== null}
        <UserMenu />
      {/if}
    </div>
  </nav>
</header>

<div class="wrapper relative">
  <main class="container mx-auto max-w-7xl relative">
    <slot />
  </main>
  <div class="absolute top-0 right-5">
    {#each $toastStore as { message, ...rest } (rest.id)}
      <TimedToast
        {...rest}
        on:toast:closed={handleClosed}
        class="fixed top-5 right-3 z-50"
      >
        {message}
      </TimedToast>
    {/each}
  </div>
</div>
